/* global */

import _ from 'lodash'

class ScreenWrapper {
    install (Vue, options) {
        Vue.prototype.$screen = {
            is (screen) {
                const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

                // @see tailwind.config.js
                const breakpoint = _.get({
                    xs: '374px',
                    sm: '576px',
                    md: '731px',
                    lg: '992px',
                    xl: '1200px',
                    '2xl': '1400px',
                    '3xl': '1800px'
                }, screen)

                if (!breakpoint) {
                    return false
                }

                return width >= parseInt(breakpoint, 10)
            }
        }
    }
}

export default new ScreenWrapper()
